/**
 *  ContextMenu script file
 **/
import proj4 from 'proj4'

export default {
  name: 'app-contextMenu',
  components: {},
  props: {
    coordinates: {
      type: Array,
      required: true
    },
    origin: {
      type: Object
    },
    destination: {
      type: Object
    },
    building: {
      type: Number,
      required: true
    },
    floor: {
      type: Number,
      required: true
    },
    floorName: {
      type: String,
      required: true
    },
    loadRoute: {
      type: Function
    },
    setLocation: {
      type: Function
    },
    addContextMenuMarkerSelected: {
      type: Function
    },
    hasGraph: {
      type: Boolean
    }
  },
  data () {
    return {
      debugMode: process.env.VUE_APP_DEBUG_MODE === 'true',
      has_graph: this.hasGraph
    }
  },
  computed: {
    coordinates4326 () {
      // LAT/LON to match the GeoJSON specification.
      const lat = Number(this.coordinates[1].toFixed(5))
      const lon = Number(this.coordinates[0].toFixed(5))
      return [lat, lon]
    },
    coordinates3857 () {
      const coord = proj4('EPSG:4326', 'EPSG:3857', [
        this.coordinates[0],
        this.coordinates[1]
      ])
      return [Number(coord[0].toFixed(0)), Number(coord[1].toFixed(0))]
    }
  },
  methods: {
    click (destination) {
      const feature = {
        geometry: {
          coordinates: this.coordinates,
          type: 'Point'
        },
        properties: {
          level: this.floor,
          levelName: this.floorName,
          building: this.building,
          icon: 'marcadores/pp_00-mk.svg'
        },
        type: 'Feature',
        mode: 'point'
      }
      this.setLocation([feature])
      this.loadRoute({
        i18n: this.$i18n,
        [destination]: feature,
        contextual: true,
        routeMode: true
      })

      this.addContextMenuMarkerSelected(feature)

      this.close()
    },
    close () {
      this.$emit('close')
    },
    copyText (input) {
      let text = ''
      switch (input) {
        case 'lat':
          text = this.$refs.lat
          break
        case 'lon':
          text = this.$refs.lon
          break
        case 'x':
          text = this.$refs.x
          break
        case 'y':
          text = this.$refs.y
          break
      }
      text.select()
      document.execCommand('copy')
    }
  }
}
